<template>
	<div id="search-input" v-bind:class="{active: showResults}">
		<template>
			<form class="search-container">
				<input class="form-control border-0 shadow-dk pl-input" 
					aria-label="Search" 
					autocomplete="off" 
					ref="input"
					type="search" 
					v-model="value"
					v-bind:placeholder="placeholder" 
					v-bind:class="{'no-round-bottom':noRoundBottom && this.deviceType !== 'mobile'}"
					v-on:keyup.prevent="keyup" 
					v-on:focus="searchFocus" 
					v-on:blur="searchBlur" 
					v-on:keydown.enter.prevent.stop="enter"
				/>
				<i v-if="this.deviceType === 'mobile' && this.showResults" class="material-icons position-absolute search-icon md-24" v-on:click="searchHide">arrow_back_ios</i>
				<i v-else class="material-icons position-absolute search-icon md-24">search</i>
				
				<div v-if="this.isLoading" class="loading-dots">
					<div class="dot"></div>
					<div class="dot"></div>
					<div class="dot"></div>
				</div>
				<i v-if="this.showResults" class="material-icons close-btn md-24" v-on:click="searchClear">close</i>
			</form>
			<div class="results-container" v-if="hasResults && showResults" v-on:mouseenter="resultsMouseEnter" 
				v-on:mouseleave="resultsMouseLeave" v-cloak>

				<div class="row no-gutters result" v-for="(res, index) in results" 
					v-on:click.prevent.stop="resultSelect(res)" 
					v-bind:class="{'select': res.id === selected}">
					<div class="col text-truncate">
						{{res.title}} <small v-if="res.subtitle" class="text-muted">{{res.subtitle}}</small><br>
						<small v-if="res.footer" class="text-muted">{{res.footer}}</small>
					</div>
				</div>
				<div class="p-2" v-if="noResults">
					<span class="text-muted">No results found</span>
				</div>
			</div>
		</template>
	</div>
</template>
<script>
export default {
	name:'search-input',

	computed:{
		value: {
			get:function(){
				return this.$store.state.search.term;
			},
			set:function(value){
				this.$store.dispatch('SEARCH_TERM_SET', {
					term:value
				});
			}
		},
		isLoading: function(){
			return this.$store.state.search.isLoading;
		},
		noResults: function(){
			return (this.value && !this.isLoading && this.value.length > 0 && 
				this.results !== null && this.results < 1)? true: false;
		},
		noRoundBottom: function(){
			return (this.hasResults && this.showResults && (this.noResults || (this.results !== null && 
				this.results.length > 0)))? true: false;
		},
		deviceType:function(){
			return this.$store.state.device.type;x
		},
		searchShown:function(){
			return this.$store.state.search.shown;
		},
		searchTerm:function(){
			return this.$store.state.search.term;
		}
	},

	data: function(){
		return {
			selected:null,
			keyupTimeout:null,
			showResults:false,
			resultsOver:false,
			inputFocus:false
		}
	},
	props:{
		results:{
			type:Array
		},
		hasResults:{
			type:Boolean
		},
		placeholder:{
			type:String
		}
	},
	

	methods:{
		enter: function(){

		},
		keyup:function(e){
			if (e.keyCode === 40){ // if down, move to prev selection
				if (this.results === null || this.results.length < 1) return;
				let activeI = null;
				this.results.map((res,i)=>{
					if (res.id == this.selected) activeI = i;
				});
				if (activeI === null){
					this.selected = this.results[0].id;
				} else if (this.results[activeI+1]) {
					this.selected = this.results[activeI+1].id;
				}
				return;
			}
			if (e.keyCode === 38){ // if down, move to prev selection
				if (this.results === null || this.results.length < 1) return;
				let activeI = null;
				this.results.map((res,i)=>{
					if (res.id == this.selected) activeI = i;
				});
				if (activeI === null){
					this.selected = this.results[0].id;
				} else if (this.results[activeI-1]) {
					this.selected = this.results[activeI-1].id;
				}
				return;
			}
			if (e.keyCode === 13){
				if (this.selected === null) return;

				let activeI = null;
				this.results.map((res,i)=>{
					if (res.id == this.selected) activeI = i;
				});
				if (activeI !== null){
					this.resultSelect(this.results[activeI]);
				}
				
				return;
			}
			if (e.keyCode === 27){
				this.showResults = false;
				return this.$refs.input.blur();
			}
		},
		resultsMouseEnter: function(){
			this.resultsOver = true;
		},
		resultsMouseLeave: function(){
			this.resultsOver = false;
		},
		searchFocus: function(){
			this.resultsOver = false;
			this.showResults = true;
		},
		searchBlur: function(e){
			if (this.deviceType === 'mobile') return;
			if (!this.resultsOver){
				this.showResults = false;
				this.$store.dispatch('SEARCH_SHOWN_SET', false);
			}
		},
		searchShow:function(){
			this.inputFocus = true;
			this.showResults = true;
			this.$store.dispatch('SEARCH_SHOWN_SET', true);
			setTimeout(()=>{
				this.$refs['input'].focus();
			},50);
		},
		searchHide:function(){
			this.$store.dispatch('SEARCH_SHOWN_SET', false);
			this.showResults = false;
		},
		searchClear:function(){
			if (!this.searchTerm){
				this.searchHide();
				return;
			}
			this.$store.dispatch('SEARCH_TERM_SET', {
				term:''
			});
			this.$refs['input'].focus();
		},
		resultSelect: function(result){
			this.$store.dispatch('SEARCH_RESULT_SELECT', result);
			this.resultGo(result.route);
		},
		resultGo: function(route){
			this.showResults = false;
			this.$store.dispatch('SEARCH_SHOWN_SET', false);
			this.$refs.input.blur();
			this.$router.push(route);
		}
	},
	watch:{
		results:function(newRes){
			if (newRes && newRes.length > 0) this.selected = newRes[0].id;
			else this.selected = null;
		}
	}
};
</script>
<style>

.mobile #search-input{
	position:fixed;
	z-index:1000;
	top: 10px;
   left: 54px;
   right: 10px;
}
.mobile #search-input.active{
	background-color:#263238;
}
.mobile .results-container{
	position:fixed;
	top:54px;
	left:10px;right:10px;
}
#search-input .close-btn{
	display:none;
	color:#263238;
}
.mobile #search-input .close-btn{
	display:block;
	position:absolute;
	right:10px;
	top:10px;
}

.search-container{
	position:relative;
}
.mobile .search-container{
	margin-top:.5rem;
	margin-top:0;
	height:44px;
	background-color:rgba(69,89,99,0.85);
	padding:4px;
	border-radius:0 4px 4px 0;
}

#search-input input{
	/*background-color:#455963;*/
	background-color:rgba(69,89,99,0.85);
	border:1px solid #5F7D8B;
	color:#FFFFFF;
	opacity:0.9;
	box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}
.mobile #search-input input{
	background-color:transparent;
	border:none;
	box-shadow:none;
}
#search-input input::placeholder{
	color:#EEEEEE;
}
#search-input input.no-round-bottom{
	border-bottom-left-radius:0;
	border-bottom-right-radius:0;
}
#search-input.active input::placeholder{
	color:#CCC;
}
#search-input.active input{
	border:1px solid #FFFFFF;
	color:#000;
	background-color:#FFF;
	opacity:1;
}
#search-input .results-container {
	background: #FFF;
	border-radius: 0 0 4px 4px;
	font-size:14px;
	box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}
#search-input .result {
	cursor:pointer;
	border-top: 1px solid #eaeaea;
	padding: .375rem .75rem;
}
#search-input .result:hover {
	background-color: #eaeaea;
}
#search-input .result.active {
	background-color: #eaeaea;
}
#search-input .result.select {
	background-color: #0676BD;
	color:#FFFFFF;
}
#search-input .result.select .text-muted{
	color:#CFD8DD !important;
}
#search-input .pl-input{
	padding-left:34px;
}
#search-input .search-icon{
	top:6px;
	left:6px;
	color:#FFF;
}
.mobile #search-input .search-icon{
	top:10px;
	left:10px;
}
#search-input.active .search-icon{
	color:rgb(69,89,99);
}

@keyframes dot-keyframes {
	0% {
		opacity: .4;
		transform: scale(1, 1);
	}

	50% {
		opacity: 1;
		transform: scale(1.4, 1.4);
	}

	100% {
		opacity: .4;
		transform: scale(1, 1);
	}
}

#search-input .loading-dots {
	text-align: right;
	position:absolute;
	right:10px;
	top:2px;
}
#search-input .dot {
	animation: dot-keyframes 1.4s infinite ease-in-out;
	background-color: #455963;
	border-radius: 10px;
	display: inline-block;
	height:4px;
	width:4px;
}
#search-input .dot:nth-child(2) {
	animation-delay: 0.4s;
}
#search-input .dot:nth-child(3) {
	animation-delay: 0.8s;
}


</style>


// WEBPACK FOOTER //
// src/components/search/search-input.vue